export const getters = {
    loginFormView: state => state.loginFormView
};


// WEBPACK FOOTER //
// ./src/store/modules/login/getters.js